import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import SensorsPage from '../../routes/admin/SensorsPage';

export default function InstallerAddSensorToFieldDialog(props) {
    const { open, onClose, addSensorTypes, edgeId, filterOutSensorIds } = props;

    const installerId = zibi.user.installerId;

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-descriptionx"
        >
            <SensorsPage
                showThisEdgeSensorsUnrelatedToField={true}
                filterOutSensorIds={filterOutSensorIds}
                edgeId={edgeId}
                filterByTypes={addSensorTypes}
                installerSelectSensor={true}
                installer={{ _id: installerId }}
                onSelect={sensor => props.onSelect(sensor)} />
        </Dialog>)
}